import { OrangeCircleCheckBox } from "../../../../assets/icons";
import styles from "./addressRadio.module.scss";
interface Iprops {
	isSelected?: boolean;
	children?: React.ReactNode;
    onClick : ()=> void;
}
const AddressRadio = ({ children, isSelected, onClick }: Iprops) => {
	return (
		<div className={`${styles.container} ${isSelected && styles.isSelected}`}>
			<button className={styles.radioIcon} onClick={onClick}>
				{isSelected && <OrangeCircleCheckBox />}
			</button>
			<div className={styles.styleContainer}>{children}</div>
		</div>
	);
};

export default AddressRadio;
